import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useCariIlgiBildirim } from '../../hooks/useCariIlgiBildirim';
import { useTabActions } from '../../contexts/tab-navigation';
import { setCariListLaunch } from '../../utils/cariListLaunch';
import { resetCarilistCache } from '../../pages/CARI/carilist';
import routes from '../../app-routes';
import * as glb from '../../globals';
import Dict from '../../messages';
import './cari-ilgi-bildirim-badge.scss';

function findCariRoute() {
  const screens = Array.isArray(glb.default.EKRANLkp) ? glb.default.EKRANLkp : [];
  const cariScreen = screens.find((x) => String(x.EKR_EKRANADI || '').toLowerCase() === 'cari');
  const navPath = cariScreen ? `/${cariScreen.EKR_EKRANADI}` : '/CARI';
  return routes.find((r) => String(r.path || '').toUpperCase() === navPath.toUpperCase())
    || routes.find((r) => String(r.path || '').toLowerCase() === '/cari');
}

function findWhatsAppBildirimRoute() {
  return routes.find((r) => String(r.path || '').toUpperCase() === '/RAPOR_WHATSAPP_BILDIRIM');
}

export default function CariIlgiBildirimBadge() {
  const { ozet } = useCariIlgiBildirim();
  const { openTab } = useTabActions();
  const history = useHistory();

  const openIlgiList = useCallback(() => {
    if (ozet.genel_yetkili) {
      const reportRoute = findWhatsAppBildirimRoute();
      if (!reportRoute?.component) return;
      openTab(reportRoute.path, 'WhatsApp Bildirim Listesi', reportRoute.component);
      try {
        if (history.location?.pathname !== '/home') history.push('/home');
      } catch (_) { /* ignore */ }
      return;
    }
    const route = findCariRoute();
    if (!route?.component) return;

    resetCarilistCache();
    setCariListLaunch({ mode: 'ilgiIsteyen' });

    const screens = Array.isArray(glb.default.EKRANLkp) ? glb.default.EKRANLkp : [];
    const cariScreen = screens.find((x) => String(x.EKR_EKRANADI || '').toLowerCase() === 'cari');
    const title = Dict.get(cariScreen?.EKR_ETIKET) || Dict.get('Cari') || 'Cari';

    openTab(route.path, title, route.component);
    try {
      if (history.location?.pathname !== '/home') {
        history.push('/home');
      }
    } catch (_) { /* ignore */ }
  }, [openTab, history, ozet.genel_yetkili]);

  const sayi = Number(ozet.ilgi_sayisi) || 0;

  const title = sayi === 1
    ? 'İlgi isteyen müşteri bildirimi: 1 müşteri arama veya bilgi istiyor'
    : `İlgi isteyen müşteri bildirimi: ${sayi} müşteri arama veya bilgi istiyor`;

  return (
    <div className="cari-ilgi-bildirim-wrap" role="group" aria-label="Arama bilgi isteyenler">
      <button
        type="button"
        className="cari-ilgi-badge"
        title={title}
        onClick={openIlgiList}
        aria-label={title}
      >
        <span className="cari-ilgi-badge__icon" aria-hidden>?</span>
        <span className="header-notification-label">{Dict.get('İlgi')}</span>
        <span className="cari-ilgi-badge__count">{sayi}</span>
      </button>
    </div>
  );
}
